<template>
<svg viewBox="0 0 35 35" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-WoDeWeiXuanZhong4`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.6384 9.39374H14.6316H14.1207C12.243 5.5795 10.6882 5.57743 9.44374 6.39516C7.0225 8.93799 5.23763 16.008 4.92883 18.5142C4.9288 27.4027 15.1188 28.0968 17.2085 28.0968C22.5908 28.0968 25.6872 27.0104 27.5166 25.5481C31.0915 22.6903 30.2065 17.108 28.863 12.7329C27.4789 8.22501 25.9889 6.17724 24.8037 6.17724C22.954 6.17724 22.5026 6.81032 21.4692 8.26001L21.4692 8.26003C21.2312 8.59388 20.9623 8.97104 20.6384 9.39374ZM10.6064 15.6436C10.6064 15.1743 10.9867 14.7939 11.456 14.7939H14.9083C15.3775 14.7939 15.7579 15.1743 15.7579 15.6436C15.7579 16.1128 15.3775 16.4932 14.9083 16.4932H11.456C10.9867 16.4932 10.6064 16.1128 10.6064 15.6436ZM20.4911 14.7939C20.0218 14.7939 19.6415 15.1743 19.6415 15.6436C19.6415 16.1128 20.0218 16.4932 20.4911 16.4932H23.9434C24.4126 16.4932 24.793 16.1128 24.793 15.6436C24.793 15.1743 24.4126 14.7939 23.9434 14.7939H20.4911Z"/></svg>
</template>
<script>

export default {
  name: 'IconWoDeWeiXuanZhong4',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
